import React from 'react';
import CategoryTable from './category_table';

const CategoryProfile = (props) => {
  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  };
  return (
    <div style={styles.container}>
      <CategoryTable {...props} />
    </div>
  );
};

export default CategoryProfile;
